import IProduct, { ProductValidationConfig } from '../Product/IProduct';
import { IKitItem } from '~api/KitsAPI/utils/IKits';
import { DiscountTypes } from '~api/utils/skuDiscounts';
import { typeConfigs, PropsObject } from '~api/utils/sanitizeData';

export interface IKitCollection {
    id: number;
    name: string;
    type: string;
    subtype: string;
}

export const defaultEmptyCollection: IKitCollection = {
    id: 0,
    name: '',
    type: '',
    subtype: ''
};

export interface IKitInfo {
    cartId: number;
    collection: IKitCollection;
    name: string;
    thumb: string;
    kitItems: IKitItem[];
}

export interface ICartEngraving {
    engravedSkuId: string;
    engravingType: string;
    templateId: number;
    templatesArray: { [key: string]: number };
    message: string[];
    selectedFont: string;
    price?: number;
    discountPercent?: number;
    discountedUnitPriceWithTax?: number;
}

interface ICartItem {
    skuId: string;
    quantity: number;
    unitPriceWithTax: number;
    appliedPriceWithTax: number;
    appliedPrice?: number;
    discountPercent: number;
    discountedUnitPriceWithTax: number;
    discountableSku?: boolean;
    product: IProduct;
    offerCode?: string | null;
    isKitItem?: boolean;
    isDonationItem?: boolean;
    isFreeVirtualSkuItem?: boolean;
    isLoyaltyReward?: boolean;
    isWpOffer?: boolean;
    isReplenishable: boolean;
    isOutOfStock: boolean;
    enableReplenishment: boolean;
    replenishmentOptions: { label: string; value: string; is_chosen: boolean }[];
    replenishmentInfo: {
        collectionId: number;
        replenishmentToken: string;
    };
    kitInfo?: IKitInfo;
    isGiftItem?: boolean;
    hasEngraving?: boolean;
    engraving?: ICartEngraving;
    isEngravable?: boolean;
    collectionId?: number;
    cartId?: number;
    discountType?: DiscountTypes | null;
    hasMarkdownDiscount?: boolean;
    basePrice?: number;
    discountedUnitPrice?: number;
    itemLoyaltyPoints?: number;
    isAutomaticOffer?: boolean;
}

export const CartItemValidationConfig: PropsObject = {
    skuId: typeConfigs.string(),
    quantity: typeConfigs.number(),
    discountPercent: typeConfigs.number(),
    unitPriceWithTax: typeConfigs.number(),
    appliedPriceWithTax: typeConfigs.number(),
    discountedUnitPriceWithTax: typeConfigs.number(),
    isReplenishable: typeConfigs.boolean(),
    enableReplenishment: typeConfigs.boolean(),
    isOutOfStock: typeConfigs.boolean(),
    product: {
        type: 'object',
        data: ProductValidationConfig
    },
    replenishmentInfo: {
        type: 'object',
        data: {
            collectionId: typeConfigs.number(),
            replenishmentToken: typeConfigs.string()
        }
    },
    offerCode: typeConfigs.string({ nullable: true }),
    appliedPrice: typeConfigs.number(),
    discountType: typeConfigs.string({ nullable: true })
};

export { ICartItem };
export default ICartItem;
